<div class="flex flex-row items-center justify-between">
    <span class="flex flex-row items-baseline gap-5">
        @if (title()) {
            <h2 class="!m-0 !font-normal">{{ title() | transloco }}</h2>
        }
        <p class="!m-0 text-custom-dark-grey text-body-2">
            {{ totalItems() }}
            {{ itemsName() | transloco: { COUNT: totalItems() } | lowercase }}
        </p>
    </span>
    <div class="flex flex-row items-center gap-5">
        <div class="flex flex-row p-1 search items-center w-32">
            <fa-icon
                class="mr-2 text-gray-300 text-base"
                matIconPrefix
                size="lg"
                [icon]="['fas', 'search']" />
            <input
                class="w-4/5 bg-transparent border-none text-base placeholder:text-gray-400 outline-none"
                matInput
                type="text"
                [disabled]="searchDisabled()"
                [placeholder]="'search' | transloco"
                [(ngModel)]="searchValue"
                (keyup)="updateSearchValue()" />
            @if (searchValue().length) {
                <fa-icon
                    class="mx-2 text-gray-300 text-sm cursor-pointer"
                    matIconPrefix
                    size="lg"
                    [icon]="['far', 'xmark']"
                    (click)="clearSearch()" />
            }
        </div>

        <ng-content />
    </div>
</div>
